import template from './LabeledColorCardView.html';
import * as styles from './labeledColorCard.scss';
class LabeledColorCardController {
    static $inject = ['$element', '$timeout'];
    constructor($element, $timeout) {
        'ngInject';
        this.$element = $element;
        this.$timeout = $timeout;
        this.styles = styles;
    }
}
LabeledColorCardController.$inject = ['$element', '$timeout'];
const LabeledColorCardComponent = {
    template,
    controller: LabeledColorCardController,
    controllerAs: '$ctrl',
    bindings: {
        title: '<',
        text: '<',
        color: '<',
    },
};
export default LabeledColorCardComponent;
